function base64urlencode(str) {
    return btoa(String.fromCharCode.apply(null, new Uint8Array(str)))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
}

export async function generatePKCE() {
    const array = new Uint8Array(32);
    window.crypto.getRandomValues(array);

    const code_verifier = base64urlencode(array);

    const encoder = new TextEncoder();
    const data = encoder.encode(code_verifier);

    const hash = await crypto.subtle.digest("SHA-256", data);
    const code_challenge = base64urlencode(hash);

    return { code_verifier, code_challenge };
}
